import { gql } from '@apollo/client';

/** Entity Type Table DB - Connection For */
export const QUERY_GET_ENTITY_TYPES = gql`
  query AdminQueriesGetConnectorEntityTypes {
    AdminQueries {
      getConnectorEntityTypes {
        id
        name
        __typename
      }
    }
  }
`;
